<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <div class="row center">
                        <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name"
                            :placeholder="$t('AppAlertsCoaAlertsConfig.Organização')" class="auto-center" :dataKey="'id'" :filter="true"
                            @input="saveChosenOptionsToLocalStorage" style="width: 250px">
                            <template #option="slotProps" style="width: 500px">
                                <div v-if="loadingOrgs"> {{ $t('AppAlertsCoaAlertsConfig.Carregando, aguarde') }}</div>
                                <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                    -
                                </div>
                                <div style="padding-right: 20px" v-else>
                                    {{ slotProps.option.display_name }}
                                </div>
                            </template>
                        </Dropdown>
                        <app-button type="secondary"
                                    class="auto-center"
                                    style="background-color: #0D89EC; margin-left: 10px;"
                                    @handleClick="exportCsv">
                            <i class="pi pi-external-link" />
                            {{$t('AppAlertsCoaAlertsConfig.Exportar')}}
                        </app-button>
                    </div>
                </div>
            </div>

            <div class="kt-portlet__body no-padding" id="tableDiv">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading"
                        filterDisplay="row" :filters.sync="filters" :sortOrder="1" sortField="code_alert" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[10, 25, 50]" responsiveLayout="scroll"
                        :currentPageReportTemplate="$t('AppAlertsCoaAlertsConfig.Mostrando {first} até {last} de {totalRecords} Alertas')"
                        class="p-datatable-striped">

                        <template #header>
                            <div style="display: flex; justify-content: space-between;">
                                <div style="font-size: 20px; font-weight: 500;">{{ $t('AppAlertsCoaAlertsConfig.Alertas') }}</div>
                                <Button :label="$t('AppAlertsCoaAlertsConfig.Adicionar')" icon="pi pi-plus" @click="handleNew" />
                            </div>
                        </template>
                        <template #empty>
                            {{ $t('AppAlertsCoaAlertsConfig.Sem dados para exibir') }}
                        </template>

                        <Column :header="$t('AppAlertsCoaAlertsConfig.Código do Alerta')" field="code_alert" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.code_alert }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Tipo de Alerta')" field="type" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.type }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsAlertType"
                                            :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Parâmetro')" field="parameter" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true" :styles="{'max-width': '9rem'}">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.parameter }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsParameter"
                                            :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Tipo')" field="vehicle_type" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true" :styles="{'max-width': '9rem'}">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.vehicle_type }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsVehicleType"
                                            :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Modelo')" field="vehicle_name" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true" :styles="{'max-width': '8rem'}">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.vehicle_name }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsVehicleName"
                                            :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Criticidade')" field="criticality_level" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true" :styles="{'max-width': '9rem'}">
                            <template #body="slotProps">
                                <span :class="'badge criticalityLevel-' + slotProps.data.criticality_level">
                                    {{ getCriticalityLevel(slotProps.data.criticality_level) }}
                                </span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsCriticalityLevel"
                                        :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                                        class="p-column-filter width-multiselect" :showClear="true" optionLabel="code" optionValue="code">
                                    <template #value="slotProps">
                                        <span v-for="singleValue in slotProps.value" :class="'badge criticalityLevel-' + singleValue" style="margin-right: 5px;">
                                            {{ getCriticalityLevel(singleValue) }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <span :class="'badge criticalityLevel-' + slotProps.option.code">
                                            {{ getCriticalityLevel(slotProps.option.code) }}
                                        </span>
                                    </template>
                                </MultiSelect>
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Referência Gráfico Min')" field="reference_value_chart_min" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValue(slotProps.data.reference_value_chart_min) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Referência Gráfico Máx')" field="reference_value_chart_max" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ formatValue(slotProps.data.reference_value_chart_max) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column :header="$t('AppAlertsCoaAlertsConfig.Status')" field="status" headerClass="headerClass"  :showFilterMenu="false"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true" :styles="{'max-width': '9rem'}">
                            <template #body="slotProps">
                                <span :class="'badge statusAlert-' + slotProps.data.status">
                                    {{ getStatus(slotProps.data.status) }}
                                </span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsStatus"
                                        :placeholder="$t('AppAlertsCoaAlertsConfig.Selecione')" appendTo="tableDiv"
                                        class="p-column-filter width-multiselect" :showClear="true" optionLabel="code" optionValue="code">
                                    <template #value="slotProps">
                                        <span v-for="singleValue in slotProps.value" :class="'badge statusAlert-' + singleValue" style="margin-right: 5px;">
                                            {{ getStatus(singleValue) }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <span :class="'badge statusAlert-' + slotProps.option.code">
                                            {{ getStatus(slotProps.option.code) }}
                                        </span>
                                    </template>
                                </MultiSelect>
                            </template>
                        </Column>
                        <Column bodyClass="bodyClass" headerClass="headerClass" :styles="{'min-width': '6rem', 'max-width': '6rem'}">
                            <template #body="slotProps">
                                <Button icon="pi pi-pencil" class="p-button-rounded"
                                    :class="'p-button-success'"
                                    style="margin-right: 10px" @click="handleEdit(slotProps.data)" />
                                <Button icon="pi pi-times" class="p-button-rounded"
                                    :class="'p-button-danger'" @click="handleDelete(slotProps.data)" />
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <Dialog :visible.sync="selectAlertDialog" :header="headerDialog" :modal="true"
                        :contentStyle="{ 'max-width': '90vw', 'width': !selectedAlertType ? '470px' : '890px', 'overflow': 'visible'}">
                    <div v-if="!selectedAlertType" class="alert-type-container">
                        <div class="alert-type-option" @click="selectAlertType('simple')">
                            {{$t('AppAlertsCoaAlertsConfig.simple')}}
                        </div>
                        <div class="alert-type-option" @click="selectAlertType('composite')">
                            {{$t('AppAlertsCoaAlertsConfig.composite')}}
                        </div>
                        <div class="alert-type-option" @click="selectAlertType('algorithm')">
                            {{$t('AppAlertsCoaAlertsConfig.algorithm')}}
                        </div>
                        <div class="alert-type-option" @click="selectAlertType('machine')">
                            {{$t('AppAlertsCoaAlertsConfig.machine')}}
                        </div>
                    </div>

                    <section v-if="selectedAlertType === 'simple'">
                        <app-alerts-coa-alerts-config-simple
                            @reloadFailures="getFailures"
                            @closeDialog="selectAlertDialog = false"
                            :optionsSensors="optionsSensors"
                            :optionsManufacturers="optionsManufacturers"
                            ref="alertFormSimple" />
                    </section>

                    <section v-if="selectedAlertType === 'composite'">
                        <app-alerts-coa-alerts-config-composite 
                            @reloadFailures="getFailures"
                            @closeDialog="selectAlertDialog = false"
                            :optionsSensors="optionsSensors"
                            :optionsManufacturers="optionsManufacturers"
                            ref="alertFormComposite" />
                    </section>

                    <section v-if="selectedAlertType === 'algorithm'">
                        <app-alerts-coa-alerts-config-algorithm 
                            @reloadFailures="getFailures"
                            @closeDialog="selectAlertDialog = false"
                            :optionsManufacturers="optionsManufacturers"
                            ref="alertFormAlgorithm" />
                    </section>

                    <section v-if="selectedAlertType === 'machine'">
                        <app-alerts-coa-alerts-config-machine 
                            @reloadFailures="getFailures"
                            @closeDialog="selectAlertDialog = false"
                            @editMachine="editMachine"
                            :optionsManufacturers="optionsManufacturers"
                            ref="alertFormMachine" />
                    </section>

                    <section v-if="selectedAlertType === 'machine-edit'">
                        <app-alerts-coa-alerts-config-machine-edit
                            @reloadFailures="getFailures"
                            @closeDialog="selectAlertDialog = false"
                            :dataToEditMachine="dataToEditMachine"
                            ref="alertFormMachineEdit" />
                    </section>
                </Dialog>

                <Dialog :visible.sync="deleteAlertDialog" :contentStyle="{ 'max-width': '90vw', 'width': '500px' }" :header="$t('AppAlertsCoaAlertsConfig.Excluir Alerta')" :modal="true">
                    <div class="confirmation-content">
                        <div>
                            {{ $t('AppAlertsCoaAlertsConfig.Tem certeza que deseja excluir o alerta?') }}
                        </div>
                    </div>
                    <template #footer>
                        <Button :label="$t('AppAlertsCoaAlertsConfig.Cancelar')" icon="pi pi-times" class="p-button-text p-button-danger" @click="deleteAlertDialog = false"/>
                        <Button :label="$t('AppAlertsCoaAlertsConfig.Confirmar')" icon="pi pi-check" class="p-button-text" @click="deleteAlert"/>
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import AppDateTimeControlBar from "../../../common/AppDateTimeControlBar";
import AppAlertsCoaAlertsConfigSimple from './AppAlertsCoaAlertsConfigSimple.vue';
import AppAlertsCoaAlertsConfigComposite from './AppAlertsCoaAlertsConfigComposite.vue';
import AppAlertsCoaAlertsConfigMachine from './AppAlertsCoaAlertsConfigMachine.vue';
import AppAlertsCoaAlertsConfigMachineEdit from './AppAlertsCoaAlertsConfigMachineEdit.vue';
import AppAlertsCoaAlertsConfigAlgorithm from './AppAlertsCoaAlertsConfigAlgorithm.vue';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button/Button';
import Dialog from 'primevue/dialog/Dialog';
import AppButton from '../../../common/AppButton.vue';
import OrganizationsService from "@/services/OrganizationsService";
import VehiclesManufacturersService from '../../../../services/VehiclesManufacturersService';
import AlertsCoaService from '@/services/AlertsCoaService';
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import displayToast from '@/mixins/ToastMixin';
import formatValue from '@/mixins/ValuesFormat';
import { CRITICALY_LEVELS, STATUSES_ALERT, VEHICLES_TYPES } from '../AppOptionsCoa';
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import {FilterMatchMode} from 'primevue/api';

export default {
    mixins: [orderCustomFieldByNaturalOrder, exportJsonToCsv, displayToast, formatValue],
    created() {
        this.organizationsService = new OrganizationsService();
        this.vehiclesManufacturersService = new VehiclesManufacturersService();
        this.alertsCoaService = new AlertsCoaService();
    },
    mounted() {
        this.getOrganizations();
        this.getManufacturers();
    },
    data() {
        return {
            loading: false,
            organizationsService: null,
            vehiclesManufacturersService: null,
            alertsCoaService: null,
            loadingOrgs: false,
            selectedOrg: null,
            organizations: [],
            storedChosenOptions: {},
            gridData: [],
            optionsVehicleName: [],
            optionsParameter: [],
            optionsVehicleType: [],
            optionsSensors: [],
            optionsCriticalityLevel: CRITICALY_LEVELS,
            optionsStatus: STATUSES_ALERT,
            deleteAlertDialog: false,
            itemToDelete: null,
            isNewAlert: false,
            optionsManufacturers: [],
            filters: {
                'code_alert': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'type': {value: null, matchMode: FilterMatchMode.IN},
                'parameter': {value: null, matchMode: FilterMatchMode.IN},
                'vehicle_type': {value: null, matchMode: FilterMatchMode.IN},
                'vehicle_name': {value: null, matchMode: FilterMatchMode.IN},
                'criticality_level': {value: null, matchMode: FilterMatchMode.IN},
                'reference_value_chart_min': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'reference_value_chart_max': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'status': {value: null, matchMode: FilterMatchMode.IN}
            },
            selectAlertDialog: false,
            optionsAlertType: [],
            selectedAlertType: null,
            headerDialog: ''
        }
    },
    methods: {
        handleNew(){
            this.selectAlertDialog = true
            this.selectedAlertType = null
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Selecione o tipo de Alerta')
        },
        selectAlertType(type) {
            this.isNewAlert = true
            this.selectedAlertType = type;
            switch (type) {
                case 'simple':
                    this.openFormSimple()
                    break;
                case 'composite':
                    this.openFormComposite()
                    break;
                case 'algorithm':
                    this.openFormAlgorithm()
                    break;
                case 'machine':
                    this.openFormMachine()
                    break;
                default:
                    break;
            }
        },
        openFormSimple() {
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Cadastrar Alerta Simples')
            let interval = setInterval(() => {
                if (this.$refs.alertFormSimple) {
                    clearInterval(interval);
                    this.$refs.alertFormSimple.cleanForm(this.selectedOrg.id);
                }
            }, 50);
        },
        openFormComposite() {
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Cadastrar Alerta Composto')
            let interval = setInterval(() => {
                if (this.$refs.alertFormComposite) {
                    clearInterval(interval);
                    this.$refs.alertFormComposite.cleanForm(this.selectedOrg.id);
                }
            }, 50);
        },
        openFormAlgorithm() {
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Gerenciar Alerta de Algoritmo')
            let interval = setInterval(() => {
                if (this.$refs.alertFormAlgorithm) {
                    clearInterval(interval);
                    this.$refs.alertFormAlgorithm.cleanForm(this.selectedOrg.id);
                }
            }, 50);
        },
        openFormMachine() {
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Gerenciar Alerta de Máquina')
            let interval = setInterval(() => {
                if (this.$refs.alertFormMachine) {
                    clearInterval(interval);
                    this.$refs.alertFormMachine.cleanForm(this.selectedOrg.id);
                }
            }, 50);
        },
        handleEdit(val){
            this.selectAlertDialog = true
            this.isNewAlert = false
            this.selectedAlertType = val.original_type;
            switch (this.selectedAlertType) {
                case 'simple':
                    this.openFormEditSimple(val)
                    break;
                case 'composite':
                    this.openFormEditComposite(val)
                    break;
                case 'algorithm':
                    this.openFormEditAlgorithm(val)
                    break;
                case 'machine':
                    this.openFormEditMachine(val)
                    break;
                default:
                    break;
            }
        },
        openFormEditSimple(val){
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Editar Alerta Simples')
            let interval = setInterval(() => {
                if (this.$refs.alertFormSimple) {
                    clearInterval(interval);
                    this.$refs.alertFormSimple.editForm(this.selectedOrg.id, val);
                }
            }, 50);
        },
        openFormEditComposite(val){
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Editar Alerta Composto')
            let interval = setInterval(() => {
                if (this.$refs.alertFormComposite) {
                    clearInterval(interval);
                    this.$refs.alertFormComposite.editForm(this.selectedOrg.id, val);
                }
            }, 50);
        },
        openFormEditAlgorithm(val){
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Gerenciar Alertas de Algoritmo')
            let interval = setInterval(() => {
                if (this.$refs.alertFormAlgorithm) {
                    clearInterval(interval);
                    this.$refs.alertFormAlgorithm.editForm(this.selectedOrg.id, val);
                }
            }, 50);
        },
        openFormEditMachine(val){
            this.headerDialog = this.$t('AppAlertsCoaAlertsConfig.Editar Alertas de Maquina')
            this.selectedAlertType = 'machine-edit'

            let newData = { ... val}
            newData.organization_id = this.selectedOrg.id,
            newData.model_name = val.vehicle_name
            this.dataToEditMachine = newData
        },
        exportCsv(){
            let csvData = [];
            JSON.parse(JSON.stringify(this.gridData)).forEach(data => {
                data.criticality_level = this.getCriticalityLevel(data.criticality_level)
                data.status = this.getStatus(data.status)
                csvData.push(data)
            });

            const CSV_FIELDS = [
                'code_alert', 'parameter', 'unit', 'vehicle_type', 'vehicle_name', 'criticality_level', 'reference_value_chart_min', 'reference_value_chart_max',
                'alert_value_min_attention', 'alert_value_min_critical', 'alert_value_min_time', 'alert_value_max_attention', 'alert_value_max_critical',
                'alert_value_max_time', 'alert_message_min_attention', 'alert_message_min_critical', 'alert_message_max_attention', 'alert_message_max_critical', 'status'
            ]
            const CSV_LABELS = [
                this.$t('AppAlertsCoaAlertsConfig.Código do Alerta'),
                this.$t('AppAlertsCoaAlertsConfig.Parâmetro'),
                this.$t('AppAlertsCoaAlertsConfig.Unidade'),
                this.$t('AppAlertsCoaAlertsConfig.Tipo'),
                this.$t('AppAlertsCoaAlertsConfig.Modelo'),
                this.$t('AppAlertsCoaAlertsConfig.Criticidade'),
                this.$t('AppAlertsCoaAlertsConfig.Referência Gráfico Min'),
                this.$t('AppAlertsCoaAlertsConfig.Referência Gráfico Máx'),
                this.$t('AppAlertsCoaAlertsConfig.Alerta Mínimo Atenção'),
                this.$t('AppAlertsCoaAlertsConfig.Alerta Mínimo Crítico'),
                this.$t('AppAlertsCoaAlertsConfig.Alerta Mínimo Tempo'),
                this.$t('AppAlertsCoaAlertsConfig.Alerta Máximo Atenção'),
                this.$t('AppAlertsCoaAlertsConfig.Alerta Máximo Crítico'),
                this.$t('AppAlertsCoaAlertsConfig.Alerta Máximo Tempo'),
                this.$t('AppAlertsCoaAlertsConfig.Mensagem de Alerta Mínimo Atenção'),
                this.$t('AppAlertsCoaAlertsConfig.Mensagem de Alerta Mínimo Crítico'),
                this.$t('AppAlertsCoaAlertsConfig.Mensagem de Alerta Máximo Atenção'),
                this.$t('AppAlertsCoaAlertsConfig.Mensagem de Alerta Máximo Crítico'),
                this.$t('AppAlertsCoaAlertsConfig.Status')
            ]

            this.exportJsonToCsv(CSV_FIELDS, CSV_LABELS, csvData, "sensores");
        },
        handleDelete(val){
            this.deleteAlertDialog = true
            this.itemToDelete = val
        },
        deleteAlert(){
            this.deleteAlertDialog = false
            if(this.itemToDelete.original_type === 'simple') {
                this.alertsCoaService.deleteSimpleAlert(this.selectedOrg.id, this.itemToDelete.id).then((data) => {
                        this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Excluido com sucesso'), 's')
                        this.getFailures()
                    }).catch((error) => {
                        this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível excluir o alerta'), 'e', error)
                    })
                return
            }

            if(this.itemToDelete.original_type === 'machine') {
                this.alertsCoaService.deleteMachineAlert(this.selectedOrg.id, this.itemToDelete.id).then((data) => {
                        this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Excluido com sucesso'), 's')
                        this.getFailures()
                    }).catch((error) => {
                        this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível excluir o alerta'), 'e', error)
                    })
                return
            }

            this.alertsCoaService.deleteCompositeAlert(this.selectedOrg.id, this.itemToDelete.id).then((data) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Excluido com sucesso'), 's')
                    this.getFailures()
                }).catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível excluir o alerta'), 'e', error)
                })
        },
        getOrganizations() {
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('VEHICLES').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível buscar organizações'), 'e', error)
            }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        getStatus(status) {
            let result = this.optionsStatus.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        getCriticalityLevel(status) {
            let result = this.optionsCriticalityLevel.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        uniquePush(array, name) {
            if (name != null && name != undefined && array.length === 0) {
                array.push({ code: array.length, name });
                return
            }

            if ((name != null && name != undefined) && !array.some(item => item.name === name)) {
                array.push({ code: array.length, name });
            }
        },
        getFailures(){
            this.loading = true
            this.selectAlertDialog = false
            this.alertsCoaService.getAlerts(this.selectedOrg.id).then((data) => {
                data.forEach(element => {
                    if(element.parameter){
                        element.parameter = element.parameter + " (" + element.unit + ")"
                    }

                    element.original_type = element.type;
                    element.type = this.$t('AppAlertsCoaAlertsConfig.' + element.type);
                    this.uniquePush(this.optionsParameter, element.parameter);
                    this.uniquePush(this.optionsAlertType, element.type);
                });
                this.setVehicleByManufacturer(data)
            }).catch((error) => {
                this.loading = false;
                this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível buscar os alertas'), 'e', error)
            })
            this.displayMaximizable = false;
        },
        getManufacturers(){
            this.vehiclesManufacturersService.getManufacturers().then((data) => {
                data.sort((a, b) => a.name.localeCompare(b.name));
                this.optionsManufacturers = data
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível buscar os fabricantes'), 'e', error)
            })
        },
        async setVehicleByManufacturer(data) {
            let manufacturers = [...new Set(data.map(item => item.manufacturer_id))];

            let promises = manufacturers.map((manufacturerId) => {
                return this.vehiclesManufacturersService.findAllModelsByManufacturerId(manufacturerId);
            });

            try {
                let results = await Promise.all(promises);

                data.forEach(element => {
                    let manufacturerModels = results.find(result => result.id === element.manufacturer_id);
                    let vehicleModel = manufacturerModels ? manufacturerModels.models.find(item => item.id === element.vehicles_manufacturer_models_id) : null;
                    element.vehicle_type = vehicleModel ? VEHICLES_TYPES.find(item => item.value === vehicleModel.vehicle_type).name : null;
                    element.vehicle_name = vehicleModel ? vehicleModel.name : null;

                    this.uniquePush(this.optionsVehicleType, element.vehicle_type);
                    this.uniquePush(this.optionsVehicleName, element.vehicle_name);

                    if (element.original_type === 'machine') {
                        element.criticality_level = element.criticality_level_coa
                    }
                });

                this.gridData = data
            } catch (error) {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Não foi possível buscar os modelos'), 'e', error)
            } finally {
                this.loading = false;
            }
        },
        editMachine(data){
            this.selectedAlertType = 'machine-edit'
            this.dataToEditMachine = data
        }
    },
    watch: {
        selectedOrg: function (val) {
            this.getFailures()

            this.alertsCoaService.getSensorsByOrg(val.id).then((data) => {
                this.optionsSensors = data
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível buscar os sensores'), 'e', error)
            })
        }
    },
    components: {
        Dropdown,
        MultiSelect,
        DataTable,
        Column,
        InputText,
        Button,
        Dialog,
        AppButton,
        AppDateTimeControlBar,
        AppAlertsCoaAlertsConfigSimple,
        AppAlertsCoaAlertsConfigComposite,
        AppAlertsCoaAlertsConfigMachine,
        AppAlertsCoaAlertsConfigAlgorithm,
        AppAlertsCoaAlertsConfigMachineEdit
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/primevue";
@import "src/components/views/alerts-coa/style";

.alert-type-container{
    display: grid; 
    grid-template-columns: repeat(2, 1fr); 
    gap: 20px;
    flex: 1 1;
}

.alert-type-option{
    height: 80px;
    width: 100%;
    color: white;
    background-color: #649B9E;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

@media (max-width: 1024px){
    .data-table-width{
        width: 100vw;
    }
}

@media (min-width: 1025px){
    .data-table-width{
        max-width: calc(100vw - 140px);
    }
}
</style>
